export default __webpack_public_path__ + "static/media/FourStars.9addde3f.svg";